import { isValidEmail } from "../../pages/Location/LocationPage/LocationOptionForm/validationUtils";
export const initialReactions = {
    access: 'Hidden',
    items: []
};
export const validateReactionForm = (state)=>{
    const messages = [];
    if (state.authorScreenName.trim().length == 0) messages.push({
        kind: "error",
        message: "Naam mag niet ontbreken."
    });
    if (state.authorEmail.trim().length == 0) {
        messages.push({
            kind: "error",
            message: "E-mailadres mag niet ontbreken."
        });
    } else if (!isValidEmail(state.authorEmail)) {
        messages.push({
            kind: "error",
            message: "E-mailadres moet geldig zijn."
        });
    }
    if (!state.editorState.getCurrentContent().hasText()) messages.push({
        kind: "error",
        message: "Bericht mag niet ontbreken."
    });
    return messages;
};
